import type { OnboardingPolicy } from '../onboardingPolicy'

// UK has no onboarding steps yet (patientStore temporarily treats UK patients as onboarded).
export const ukOnboarding: OnboardingPolicy = {
  buildActions: () => [],
  allowedPaths: [],
}
